import { FileIconFactory } from "./file-icon-factory";
import { getDeviceMachine } from "../util/device-machine";
export var FileIcon = FileIconFactory({
  getMachine: getDeviceMachine
});
//# sourceMappingURL=file-icon.js.map